import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EtatVide } from '../composants/EtatVide.js';
/** Mon abonnement et mes quotas consommés (§6.6). */
export function Abonnement({ t, urlTarifs }) {
    return (_jsxs(_Fragment, { children: [_jsx("h1", { className: "titre-ecran", children: t('app.monAbonnement') }), _jsx(EtatVide, { titre: t('etat.vide.titre'), texte: t('app.etat.vide.abonnement'), action: _jsx("a", { className: "etat-vide__action", href: urlTarifs, children: t('action.voirLesTarifs') }) })] }));
}
//# sourceMappingURL=Abonnement.js.map